export const crmPath = "/leads";

// TODO: Delete this aggregation
export const paths = {
  contacts: `${crmPath}/people`,
  companies: `${crmPath}/companies`,
  lists: `${crmPath}/lists`,
  imports: `${crmPath}/imports`,
};

// TODO: Delete
export const stageCategories = {
  cold: "cold",
  engaging: "engaging",
  positive: "positive",
  negative: "negative",
};

// TODO: Delete
export const stageColors = {
  [stageCategories.cold]: "#7C98B6",
  [stageCategories.engaging]: "#FF7A59",
  [stageCategories.positive]: "#00BDA5",
  [stageCategories.negative]: "#F2545B",
};

export default crmPath;
